import { Provider } from 'react-redux';
import './App.less';
import './assets/scss/common.scss';
import RouterPath from './Router';
import { persistor, store } from './store/store';
import { PersistGate } from 'redux-persist/integration/react';
import Header from './components/Header';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { captureUtmParameters } from './utils/utmTracker';
import { initBranchIo, resetRedirectingFlag, handleMobileRedirection } from './utils/branchIoUtils';
import { getUnauthenticatedLegalRedirect } from './utils/getUnauthenticatedLegalRedirect';

function AppContent() {
  const location = useLocation();

  useEffect(() => {
    // Handle mobile redirection for all routes when location changes
    handleMobileRedirection(location.pathname);
  }, [location.pathname]);

  return <RouterPath />;
}

function App() {
  useEffect(() => {
    // Check if redirection is needed for legal pages
    if (getUnauthenticatedLegalRedirect()) {
      // If redirection happened, return early
      return;
    }
    
    // Clean up any stale Branch.io state first
    resetRedirectingFlag();
    
    // Initialize everything
    captureUtmParameters();
    initBranchIo();
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className='App'>
          <Header url={window.location.href} description={''} title={''} image={''} />
          <BrowserRouter>
            <AppContent />
          </BrowserRouter>
        </div>
      </PersistGate>
    </Provider>
  );
}

export default App;